<button
  epg-icon-button
  class="epg-user-menu-portal-button"
  (click)="toggleOverlay()"
  aria-label="Open user menu"
>
  <mat-icon>menu</mat-icon>
</button>

<div class="fullscreen-overlay" [class.visible]="this.isOpen()">
  <div class="epg-user-menu-container-fullscreen">
    <div class="epg-user-menu-content-fullscreen">
      <div>
        <ng-content epg-user-profile-info></ng-content>
        <ng-content epg-language-selector></ng-content>
      </div>
      <div>
        <button epg-icon-button (click)="toggleOverlay()" aria-label="Close user menu">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <ng-content epg-user-menu-selection></ng-content>
  </div>
</div>
